import cls from "classnames";
import { useState } from "react";

import Button from "@qoohoo/common/components/library/Button";
import Tooltip from "@qoohoo/common/library/Tooltip";

const FeatureItem = ({ item, colors }) => {
  const [element, setElement] = useState(null);

  return (
    <div ref={setElement} className="flex items-center gap-1 md:gap-2 w-fit">
      <img
        src="/assets/icons/tick-green.svg"
        className={cls(
          "h-[0.875rem] w-[0.875rem] md:h-4 md:w-4",
          item.hideIcon && "hidden"
        )}
      />
      {typeof item.label === "function" ? (
        item.label()
      ) : (
        <span
          className={cls(
            "text-sm md:text-base leading-normal",
            item.tooltip && "underline cursor-pointer"
          )}
          style={{ color: colors.text }}
        >
          {item.label}
        </span>
      )}
      {item.tooltip && (
        <Tooltip referenceElement={element} description={item.tooltip} />
      )}
    </div>
  );
};

export default function PricingPlanCard({
  className,
  style,
  colors,
  title,
  titleColor: _titleColor,
  cardBanner,
  price,
  priceDescription,
  buttonText,
  buttonStyle,
  onButtonClick,
  data,
}) {
  const titleColor = _titleColor || colors.text;

  return (
    <div className="flex-1 flex flex-col shrink-0">
      {cardBanner && (
        <div
          className="w-full py-1 flex items-center justify-center gap-1 rounded-t-lg border-t-2"
          style={{ background: titleColor, color: "#FFFFFF", borderColor: titleColor }}
        >
          {cardBanner.icon && <img src={cardBanner.icon} className="h-3 w-3 md:h-4 md:w-4" />}
          <span className="text-[10px] leading-3 md:text-[0.8125rem] md:leading-4 font-bold select-none">
            {cardBanner.label}
          </span>
        </div>
      )}
      <div
        className={cls(
          "flex flex-col px-4 py-6 md:px-6 flex-1 shrink-0 rounded-lg",
          cardBanner && "rounded-t-none",
          className
        )}
        style={{
          ...style,
        }}
      >
        <div className="w-full flex items-center justify-between">
          <span
            className="text-sm md:text-lg leading-normal font-bold"
            style={{
              color: titleColor,
            }}
          >
            {title}
          </span>
        </div>
        <div className="mt-6" style={{ color: colors.text }}>
          {typeof price === "function" ? (
            price()
          ) : (
            <span className="font-extrabold text-2xl md:text-[2rem] leading-normal">
              {price}
            </span>
          )}
        </div>
        {priceDescription && (
          <span
            className="font-sm md:font-base"
            style={{ color: colors.text, opacity: 0.6 }}
          >
            {priceDescription}
          </span>
        )}
        <Button
          className="w-[7.5rem] md:w-52 !h-9 md:!h-10 !rounded md:!rounded-md mt-3 md:mt-6"
          style={buttonStyle}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
        <div
          className="w-full h-[1px] mt-3 md:mt-9"
          style={{ background: colors.border }}
        />
        <div className="flex flex-col gap-2 md:gap-4 mt-3 md:mt-9">
          {data.map((feature, idx) => {
            return (
              <div key={idx} className="flex flex-col gap-2">
                <span
                  className="text-sm md:text-base leading-normal font-bold mb-1"
                  style={{ color: colors.text }}
                >
                  {feature.title}
                </span>
                {feature.items.map((item, idx) => (
                  <FeatureItem key={idx} item={item} colors={colors} />
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
